import Vue from 'vue'
import Vuex from 'vuex'
import Posts from './posts'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    blogPosts: Posts,
  },
  getters: {
    getPost: state => {
      return state.blogPosts;
    }
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
});
